export default __webpack_public_path__ + "static/resumeEng-d2a0ac92de8bfe57efc6ba3902c0af26.pdf";